import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { TreeMetaDisplay } from "./TreeMetaDisplay";
import LoopIcon from "@material-ui/icons/Loop";
import { TreeStructureDef } from "../../../TreeBlockDataSource";
import { t } from "../../../../../../core/i18n/i18n";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      background: theme.palette.background.paper,
      flexGrow: 0,
      flexShrink: 0,
      color: theme.palette.text.primary,
      padding: "10px",
      alignItems: "center"
    },
    autoDistributeButton: { width: 160, margin: "0px 5px" }
  })
);

export interface BodyWidgetHeaderProps {
  children?: any;
  tempStructure: TreeStructureDef | undefined;
  autoDistribute: () => void;
}

export function BodyWidgetHeader(props: BodyWidgetHeaderProps) {
  const classes = useStyles();
  const { tempStructure, autoDistribute } = props;

  return (
    <div className={classes.header}>
      <Button
        onClick={autoDistribute}
        className={classes.autoDistributeButton}
        size={"small"}
        variant={"contained"}
        color="primary"
        startIcon={<LoopIcon />}
      >
        {t("hns:tree:redistribute")()}
      </Button>
      <TreeMetaDisplay
        infos={tempStructure?.meta?.infos || []}
        warnings={tempStructure?.meta?.warnings || []}
      />
    </div>
  );
}
